import {
  ALARM_STATES,
  ALARM_STATUSES,
  PATTERN_FIELD_TYPES,
  PATTERN_OPERATORS,
  TRIGGERS_TYPES,
} from '@/constants';

export default {
  ok: 'Ok',
  undefined: 'Non défini',
  entity: 'Entité | Entités',
  alarm: 'Alarme | Alarmes',
  service: 'Service',
  widget: 'Widget',
  addWidget: 'Ajouter un widget',
  addTab: 'Ajouter un onglet',
  shareLink: 'Créer un lien de partage',
  addPbehavior: 'Ajouter un comportement périodique',
  refresh: 'Rafraîchir',
  restart: 'Redémarrer',
  toggleEditView: 'Activer/Désactiver le mode édition',
  toggleEditViewSubtitle: 'Si vous souhaitez enregistrer les positions des widgets, vous devez désactiver le mode édition',
  name: 'Nom',
  alias: 'Alias',
  namePrefix: 'Préfixe du nom',
  description: 'Description',
  author: 'Auteur',
  submit: 'Soumettre',
  cancel: 'Annuler',
  continue: 'Continuer',
  tryAgain: 'Réessayer',
  stop: 'Fin',
  options: 'Options',
  type: 'Type',
  actionType: 'Type d\'action',
  quitEditing: 'Quitter le mode édition',
  enabled: 'Activé(e)',
  disabled: 'Désactivé(e)',
  required: 'Requis(e)',
  login: 'Connexion',
  yes: 'Oui',
  no: 'Non',
  default: 'Défaut',
  confirmation: 'Êtes-vous sûr(e) ?',
  parameter: 'Paramètre | Paramètres',
  by: 'Par',
  date: 'Date',
  yesterday: 'Hier',
  data: 'Données',
  comment: 'Commentaire | Commentaires',
  end: 'Fin',
  start: 'Début',
  message: 'Message',
  preview: 'Aperçu',
  recursive: 'Récursif',
  select: 'Sélectionner',
  states: 'Criticités',
  state: 'Criticité',
  sla: 'SLA',
  authors: 'Auteurs',
  stat: 'Statistiques',
  trend: 'Tendance',
  user: 'Utilisateur | Utilisateurs',
  role: 'Rôle | Rôles',
  import: 'Importer',
  export: 'Exporter',
  profile: 'Profil',
  username: 'Identifiant utilisateur',
  password: 'Mot de passe',
  authKey: 'Clé d\'authentification',
  widgetId: 'Identifiant du widget',
  connect: 'Connexion',
  optional: 'Optionnel',
  logout: 'Se déconnecter',
  title: 'Titre',
  save: 'Sauvegarder',
  notSaved: 'Non enregistré',
  label: 'Label',
  field: 'Champ',
  fields: 'Champs',
  fieldName: 'Nom du champ',
  value: 'Valeur',
  limit: 'Limite',
  add: 'Ajouter',
  addAtLeastOneItem: 'Ajouter au moins un élément.',
  create: 'Créer',
  delete: 'Supprimer',
  show: 'Afficher',
  hide: 'Cacher',
  expandAll: 'Tout développer',
  collapseAll: 'Tout réduire',
  edit: 'Éditer',
  duplicate: 'Dupliquer',
  replace: 'Remplacer',
  play: 'Lecture',
  pause: 'Pause',
  copyLink: 'Copier le lien',
  parse: 'Analyser',
  home: 'Accueil',
  step: 'Étape',
  paginationItems: 'Affiche {first} à {last} sur {total} Entrées',
  apply: 'Appliquer',
  from: 'Depuis',
  to: 'Vers',
  tags: 'Tags',
  actionsLabel: 'Actions',
  testName: 'Nom du test',
  ruleType: 'Type de règle',
  ruleName: 'Nom de la règle',
  noResults: 'Pas de résultats',
  result: 'Résultat',
  exploitation: 'Exploitation',
  administration: 'Administration',
  forbidden: 'Accès refusé',
  notFound: 'Introuvable',
  search: 'Recherche',
  filters: 'Filtres',
  filter: 'Filtre',
  filterByType: 'Filtrer par type',
  emptyObject: 'Objet vide',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  link: 'Lien | Liens',
  edition: 'Édition',
  icon: 'Icône | Icônes',
  fullscreen: 'Plein écran',
  interval: 'Période',
  status: 'Statut',
  unit: 'Unité',
  delay: 'Délai',
  begin: 'Début',
  timezone: 'Fuseau horaire',
  reason: 'Raison',
  or: 'OU',
  and: 'ET',
  priority: 'Priorité',
  clear: 'Nettoyer',
  deleteAll: 'Tout supprimer',
  payload: 'Payload',
  note: 'Note',
  output: 'Message',
  input: 'Entrée',
  created: 'Date de création',
  updated: 'Date de dernière modification',
  expired: 'Date d\'expiration',
  accessed: 'Consulté à',
  lastEventDate: 'Date du dernier événement',
  lastPbehaviorDate: 'Date du dernier comportement périodique',
  activated: 'Activé',
  pattern: 'Modèle | Modèles',
  correlation: 'Corrélation',
  period: 'Période',
  periods: 'Périodes',
  range: 'Plage',
  duration: 'Durée',
  previous: 'Précédent',
  next: 'Suivant',
  eventPatterns: 'Modèles des événements',
  alarmPatterns: 'Modèles des alarmes',
  entityPatterns: 'Modèles des entités',
  pbehaviorPatterns: 'Modèles des comportements périodiques',
  totalEntityPatterns: 'Modèles des entités (Total)',
  serviceWeatherPatterns: 'Modèles des météos de service',
  addFilter: 'Ajouter un filtre',
  id: 'Identifiant',
  reset: 'Réinitialiser',
  selectColor: 'Sélectionner la couleur',
  disableDuringPeriods: 'Désactiver pendant les pauses',
  retryDelay: 'Délai entre les tentatives',
  retryUnit: 'Unité des tentatives',
  retryCount: 'Nombre de tentatives après échec',
  ticket: 'Ticket | Tickets',
  method: 'Méthode',
  url: 'URL',
  category: 'Catégorie',
  infos: 'Infos',
  impactLevel: 'Niveau d\'impact',
  impactState: 'État d\'impact',
  loadMore: 'Charger plus',
  download: 'Télécharger',
  initiator: 'Initiateur',
  percent: 'Pourcentage | Pourcentages',
  number: 'Nombre | Nombres',
  tests: 'Tests',
  total: 'Total',
  error: 'Erreur | Erreurs',
  failures: 'Échecs',
  skipped: 'Ignoré',
  current: 'Actuel',
  average: 'Moyenne',
  information: 'Information | Informations',
  file: 'Fichier',
  group: 'Groupe | Groupes',
  view: 'Vue | Vues',
  tab: 'Onglet | Onglets',
  access: 'Accès',
  communication: 'Communication | Communications',
  general: 'Général',
  notification: 'Notification | Notifications',
  dismiss: 'Rejeter',
  approve: 'Approuver',
  summary: 'Résumé',
  recurrence: 'Récurrence',
  statistics: 'Statistiques',
  action: 'Action | Actions',
  minimal: 'Minimal',
  optimal: 'Optimal',
  graph: 'Graphique | Graphiques',
  systemStatus: 'État du système',
  downloadAsPng: 'Télécharger en PNG',
  rating: 'Evaluation | Evaluations',
  sampling: 'Échantillonnage',
  parametersToDisplay: '{count} paramètres à afficher',
  uptime: 'Uptime',
  maintenance: 'Maintenance',
  downtime: 'Downtime',
  totalActiveTime: 'Temps d\'activité total',
  inactiveTime: 'Temps d\'inactivité',
  toTheTop: 'Vers le haut',
  time: 'Temps',
  lastModifiedOn: 'Dernière modification le',
  lastModifiedBy: 'Dernière modification par',
  exportAsCsv: 'Exporter en csv',
  exportToPdf: 'Exporter au format PDF',
  exportToJson: 'Exporter au format JSON',
  exportFieldToJson: 'Exporter {field} au format JSON',
  exportFieldToPdfOrJson: 'Exporter {field} au format PDF ou JSON',
  copyFieldPath: 'Copier le chemin {field}',
  copyFieldPathOrExportFieldToPdf: 'Copiez le chemin du {field} ou exportez le {field} au format PDF',
  copyToClipboard: 'Copier dans le presse-papier',
  copyPathToClipboard: 'Copier le chemin dans le presse-papiers',
  criteria: 'Critères',
  ratingSettings: 'Paramètres d\'évaluation',
  pbehavior: 'Comportement périodique | Comportements périodiques',
  activePbehavior: 'Activer le comportement périodique | Activer les comportements périodiques',
  searchBy: 'Recherché par',
  dictionary: 'Dictionnaire',
  condition: 'Condition | Conditions',
  template: 'Template',
  pbehaviorList: 'Lister les comportements périodiques',
  canceled: 'Annulé',
  snooze: 'Snooze',
  snoozed: 'En attente',
  impact: 'Impact | Impacts',
  depend: 'Depend | Depends',
  componentInfo: 'Information du composant | Informations du composant',
  connector: 'Type de connecteur',
  connectorName: 'Nom du connecteur',
  component: 'Composant',
  resource: 'Ressource',
  ack: 'Acquittement',
  acked: 'Acquitté',
  extraInfo: 'Extra info | Extra infos',
  custom: 'Personnalisé',
  eventType: 'Type d\'événement',
  sourceType: 'Type de Source',
  cycleDependency: 'Dépendance au cycle',
  checkPattern: 'Vérification du modèle',
  checkFilter: 'Vérifier le filtre',
  canonicalType: 'Type canonique',
  map: 'Cartographie | Cartographies',
  instructions: 'Consignes',
  playlist: 'Liste de lecture | Listes de lecture',
  ctrlZoom: 'Utilisez ctrl + molette de la souris pour zoomer',
  calendar: 'Calendrier',
  tag: 'Tag | Tags',
  sharedTokens: 'Jetons partagés',
  notAvailable: 'Indisponible',
  addMore: 'Ajouter plus',
  more: 'plus',
  all: 'Tous',
  other: 'Autre',
  attribute: 'Attribut',
  timeTaken: 'Temps passé',
  enginesMetrics: 'Métriques des moteurs',
  failed: 'Échoué',
  finished: 'Terminé',
  close: 'Fermer',
  alarmId: 'Identifiant de l\'alarme',
  entityId: 'ID d\'entité',
  longOutput: 'Sortie longue',
  timestamp: 'Horodatage',
  countOfMax: '{count} sur {total}',
  trigger: 'Déclencheur | Déclencheurs',
  column: 'Colonne | Colonnes',
  sort: 'Tri',
  countOfTotal: '{count} sur {total}',
  deprecatedTrigger: 'Ce déclencheur n\'est plus pris en charge',
  initialLongOutput: 'Sortie initiale longue',
  totalStateChanges: 'Nombre de changements d\'état',
  noReceivedEvents: 'Aucun événement reçu pendant {duration} par certaines dépendances',
  frequencyLimit: 'Nombre d\'oscillations',
  clearSearch: 'Ne plus appliquer cette recherche',
  noData: 'Aucune donnée',
  noColumns: 'Veuillez sélectionner au moins une colonne',
  noDataAvailable: 'Aucune donnée disponible',
  theme: 'Thème | Thèmes',
  systemName: 'Nom du système',
  emitTrigger: 'Émettre un déclencheur',
  header: 'En-tête | En-têtes',
  headerKey: 'Clé d\'en-tête',
  headerValue: 'Valeur d\'en-tête',
  rule: 'Règle | Règles',
  copyValue: 'Copier la valeur',
  copyProperty: 'Copier la propriété',
  copyPropertyPath: 'Copier le chemin de la propriété',
  hidden: 'Caché',
  numberField: 'Champ numérique',
  chart: 'Graphique | Graphiques',
  currentDate: 'Date actuelle',
  chooseFile: 'Choisir le fichier',
  seeAlarms: 'Voir les alarmes',
  seeEntities: 'Voir les entités',
  seeChat: 'Voir la conversation',
  new: 'Nouvelle',
  regexp: 'Expression régulière',
  archive: 'Archive',
  convertToCustomColumn: 'Convertir la colonne en personnalisé',
  event: 'Événement | Événements',
  showMore: 'Afficher plus ({current} sur {total})',
  availability: 'Disponibilité',
  testQuery: 'Tester la requête',
  webhookStatus: 'Statut du webhook',
  webhookComplete: 'Webhook terminé',
  noResponse: 'Pas de réponse',
  loadingItems: 'Chargement d\'éléments...',
  lastComment: 'Dernier commentaire',
  serialName: 'Nom de série',
  local: 'Local',
  server: 'Serveur',
  pressEnterToApply: 'Appuyez sur <kbd>Entrée</kbd> pour appliquer',
  width: 'Largeur',
  versionUpdated: 'Version mise à jour',
  database: 'Base de données',
  importData: 'Importer des données',
  separator: 'Séparateur',
  true: 'Vrai',
  false: 'Faux',
  customField: 'Champ personnalisé|Champs personnalisés',
  inProgress: 'En cours',
  last: 'Dernier',
  seeDetails: 'Voir les détails',
  calculated: 'Calculé',
  token: 'Jeton',
  requestDate: 'Date de la demande',
  settings: 'Paramètres',
  after: 'Après',
  defined: 'Défini',
  bulkDelete: 'Supprimer la sélection',
  variableTypes: {
    string: 'Chaîne de caractères',
    number: 'Nombre',
    boolean: 'Booléen',
    null: 'Nul',
    array: 'Tableau',
    stringArray: 'Tableau de chaînes',
    object: 'Object',
    timestamp: 'Horodatage',
  },
  mixedField: {
    types: {
      [PATTERN_FIELD_TYPES.string]: '@:common.variableTypes.string',
      [PATTERN_FIELD_TYPES.number]: '@:common.variableTypes.number',
      [PATTERN_FIELD_TYPES.boolean]: '@:common.variableTypes.boolean',
      [PATTERN_FIELD_TYPES.null]: '@:common.variableTypes.null',
      [PATTERN_FIELD_TYPES.stringArray]: '@:common.variableTypes.array',
      [PATTERN_FIELD_TYPES.timestamp]: '@:common.variableTypes.timestamp',
    },
  },
  saveChanges: 'Sauvegarder',
  ordinals: {
    first: 'Premier',
    second: 'Second',
    third: 'Troisième',
    fourth: 'Quatrième',
    fifth: 'Cinquième',
  },
  times: {
    millisecond: 'milliseconde | millisecondes',
    second: 'seconde | secondes',
    minute: 'minute | minutes',
    hour: 'heure | heures',
    day: 'jour | jours',
    week: 'semaine | semaines',
    month: 'mois | mois',
    year: 'année | années',
  },
  timeFrequencies: {
    secondly: 'Par seconde',
    minutely: 'Par minute',
    hourly: 'Par heure',
    daily: 'Quotidien',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuel',
    yearly: 'Annuel',
  },
  weekDays: {
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',
  },
  shortWeekDays: {
    monday: 'lun.',
    tuesday: 'mar.',
    wednesday: 'mer.',
    thursday: 'jeu.',
    friday: 'ven.',
    saturday: 'sam.',
    sunday: 'dim.',
  },
  months: {
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Août',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Décembre',
  },
  shortMonths: {
    january: 'janv.',
    february: 'févr.',
    march: 'mars',
    april: 'avr.',
    may: 'mai',
    june: 'juin',
    july: 'juil.',
    august: 'août',
    september: 'sep.',
    october: 'oct',
    november: 'nov.',
    december: 'déc.',
  },
  stateTypes: {
    [ALARM_STATES.ok]: 'Ok',
    [ALARM_STATES.minor]: 'Mineur',
    [ALARM_STATES.major]: 'Majeur',
    [ALARM_STATES.critical]: 'Critique',
  },
  statusTypes: {
    [ALARM_STATUSES.closed]: 'Fermée',
    [ALARM_STATUSES.ongoing]: 'En cours',
    [ALARM_STATUSES.flapping]: 'Bagot',
    [ALARM_STATUSES.stealthy]: 'Furtive',
    [ALARM_STATUSES.cancelled]: 'Annulée',
    [ALARM_STATUSES.noEvents]: 'Pas d\'événements',
    [ALARM_STATUSES.unknown]: 'Inconnu',
  },
  statusResolvedTypes: {
    [ALARM_STATUSES.closed]: 'Fermée et résolue',
    [ALARM_STATUSES.cancelled]: 'Annulée et résolue',
  },
  operators: {
    [PATTERN_OPERATORS.equal]: 'Égal',
    [PATTERN_OPERATORS.contains]: 'Contient',
    [PATTERN_OPERATORS.notEqual]: 'n\'est pas égal',
    [PATTERN_OPERATORS.notContains]: 'Ne contient pas',
    [PATTERN_OPERATORS.beginWith]: 'Commence par',
    [PATTERN_OPERATORS.notBeginWith]: 'Ne commence pas par',
    [PATTERN_OPERATORS.endsWith]: 'Se termine par',
    [PATTERN_OPERATORS.notEndWith]: 'Ne se termine pas par',
    [PATTERN_OPERATORS.exist]: 'Existe',
    [PATTERN_OPERATORS.notExist]: 'N\'existe pas',

    [PATTERN_OPERATORS.hasEvery]: 'Contient chaque',
    [PATTERN_OPERATORS.hasOneOf]: 'Contient l\'un des',
    [PATTERN_OPERATORS.isOneOf]: 'Est l\'un de',
    [PATTERN_OPERATORS.hasNot]: 'Ne contient pas',
    [PATTERN_OPERATORS.isNotOneOf]: 'N\'est pas l\'un des',
    [PATTERN_OPERATORS.isEmpty]: 'Est vide',
    [PATTERN_OPERATORS.isNotEmpty]: 'N\'est pas vide',

    [PATTERN_OPERATORS.higher]: 'Plus haut que',
    [PATTERN_OPERATORS.lower]: 'Plus bas que',

    [PATTERN_OPERATORS.longer]: 'Supérieur à',
    [PATTERN_OPERATORS.shorter]: 'Inférieur à',

    [PATTERN_OPERATORS.ticketAssociated]: 'Un ticket est associé',
    [PATTERN_OPERATORS.ticketNotAssociated]: 'Un ticket n\'est pas associé',

    [PATTERN_OPERATORS.canceled]: 'Annulé',
    [PATTERN_OPERATORS.notCanceled]: 'Non annulé',

    [PATTERN_OPERATORS.snoozed]: 'En attente',
    [PATTERN_OPERATORS.notSnoozed]: 'Non mis en attente',

    [PATTERN_OPERATORS.acked]: 'Acquitté',
    [PATTERN_OPERATORS.notAcked]: 'Non acquitté',

    [PATTERN_OPERATORS.isGrey]: 'Tuile grise',
    [PATTERN_OPERATORS.isNotGrey]: 'Tuile non grise',

    [PATTERN_OPERATORS.with]: 'Avec',
    [PATTERN_OPERATORS.without]: 'Sans',

    [PATTERN_OPERATORS.withLabel]: 'Avec le label',
    [PATTERN_OPERATORS.withoutLabel]: 'Sans le label',

    [PATTERN_OPERATORS.activated]: 'Activé',
    [PATTERN_OPERATORS.inactive]: 'Inactif',

    [PATTERN_OPERATORS.enabled]: 'Vrai',
    [PATTERN_OPERATORS.disabled]: 'Faux',

    [PATTERN_OPERATORS.isMetaAlarm]: 'C\'est une méta-alarme',
    [PATTERN_OPERATORS.isNotMetaAlarm]: 'Ce n\'est pas une méta-alarme',
    [PATTERN_OPERATORS.ruleIs]: 'La règle est',

    [PATTERN_OPERATORS.regexp]: 'Expression régulière',

    [PATTERN_OPERATORS.within]: 'Au cours des',
    [PATTERN_OPERATORS.olderThan]: 'Plus ancien que',
    [PATTERN_OPERATORS.inRangeDates]: 'Dans l\'intervalle (dates)',
    [PATTERN_OPERATORS.inRangePeriod]: 'Dans l\'intervalle (période)',
  },
  triggers: {
    [TRIGGERS_TYPES.create]: {
      text: 'Alarme créée',
    },
    [TRIGGERS_TYPES.statedec]: {
      text: 'Criticité de l\'alarme diminuée',
    },
    [TRIGGERS_TYPES.changestate]: {
      text: 'Criticité de l\'alarme changée par l\'action "changer de criticité"',
    },
    [TRIGGERS_TYPES.stateinc]: {
      text: 'Criticité de l\'alarme augmentée',
    },
    [TRIGGERS_TYPES.changestatus]: {
      text: 'Statut de l\'alarme changé, par ex. flapping',
    },
    [TRIGGERS_TYPES.ack]: {
      text: 'Alarme acquittée',
    },
    [TRIGGERS_TYPES.ackremove]: {
      text: 'Alarme désacquittée',
    },
    [TRIGGERS_TYPES.cancel]: {
      text: 'Alarme annulée',
    },
    [TRIGGERS_TYPES.uncancel]: {
      text: 'Alarme désannulée',
      helpText: 'Probablement un déclencheur hérité, car il n\'y a aucun moyen d\'annuler l\'alarme lorsque vous l\'annulez dans l\'interface utilisateur, mais il est possible d\'envoyer un événement d\'annulation via l\'API',
    },
    [TRIGGERS_TYPES.comment]: {
      text: 'Alarme commentée',
    },
    [TRIGGERS_TYPES.declareticket]: {
      text: 'Ticket déclaré par l\'action de l\'interface utilisateur',
    },
    [TRIGGERS_TYPES.declareticketwebhook]: {
      text: 'Ticket déclaré par le webhook',
    },
    [TRIGGERS_TYPES.assocticket]: {
      text: 'Ticket associé à une alarme',
    },
    [TRIGGERS_TYPES.ticketremove]: {
      text: 'Ticket retiré',
    },
    [TRIGGERS_TYPES.snooze]: {
      text: 'Alarme mise en veille',
    },
    [TRIGGERS_TYPES.unsnooze]: {
      text: 'Alarme sortie de veille',
    },
    [TRIGGERS_TYPES.resolve]: {
      text: 'Alarme résolue',
    },
    [TRIGGERS_TYPES.activate]: {
      text: 'Alarme activée',
    },
    [TRIGGERS_TYPES.pbhenter]: {
      text: 'Alarme entrée dans un pbehavior',
    },
    [TRIGGERS_TYPES.pbhleave]: {
      text: 'Alarme sortie d\'un pbehavior',
    },
    [TRIGGERS_TYPES.instructionfail]: {
      text: 'Consigne manuelle en erreur',
    },
    [TRIGGERS_TYPES.autoinstructionfail]: {
      text: 'Consigne automatique en erreur',
    },
    [TRIGGERS_TYPES.instructionjobfail]: {
      text: 'Job de consigne manuelle ou automatique en erreur',
    },
    [TRIGGERS_TYPES.instructionjobcomplete]: {
      text: 'Job de consigne manuelle ou automatique terminé',
    },
    [TRIGGERS_TYPES.instructioncomplete]: {
      text: 'Consigne manuelle terminée',
    },
    [TRIGGERS_TYPES.autoinstructioncomplete]: {
      text: 'Consigne automatique terminée',
    },
    [TRIGGERS_TYPES.autoinstructionresultok]: {
      text: 'L\'alarme est en état OK après toutes les consignes automatiques',
    },
    [TRIGGERS_TYPES.autoinstructionresultfail]: {
      text: 'L\'alarme n\'est pas en état OK après toutes les consignes automatiques',
    },
    [TRIGGERS_TYPES.eventscount]: {
      text: 'L\'alarme a reçu N événements',
      selectedText: 'L\'alarme a reçu {additionalValue} événements',
      additionalFieldLabel: 'Nombre d\'événements',
    },
  },
  repeatTriggers: {
    [TRIGGERS_TYPES.eventscount]: {
      text: 'L\'alarme a reçu un nouvel événement check',
      selectedText: 'L\'alarme a reçu un nouvel événement check',
    },
  },
  request: {
    timeout: 'Temps libre',
    timeoutSettings: 'Paramètres de délai d\'attente',
    repeatRequest: 'Répéter la demande',
    repeatRequestInTomlFile: 'Les paramètres de répétition sont configurés dans le fichier toml',
    skipVerify: 'Ne pas vérifier les certificats HTTPS',
    headersHelpText: 'Sélectionnez la clé et la valeur de l\'en-tête ou saisissez-les manuellement',
    emptyHeaders: 'Aucun en-tête ajouté pour le moment',
    urlHelp: '<p>Les variables accessibles sont : <strong>.Alarm</strong>, <strong>.Entity</strong> et <strong>.Children</strong></p>'
      + '<i>Quelques exemples :</i>'
      + '<pre>"https://exampleurl.com?resource={{ .Alarm.Value.Resource }}"</pre>'
      + '<pre>"https://exampleurl.com?entity_id={{ .Entity.ID }}"</pre>'
      + '<pre>"https://exampleurl.com?children_count={{ len .Children }}"</pre>'
      + '<pre>"https://exampleurl.com?children={{ range .Children }}{{ .ID }}{{ end }}"</pre>',
  },

  fileSelector: {
    dragAndDrop: {
      label: 'Glisser-déposer pour télécharger',
      labelAction: 'ou parcourir',
    },
    fileTypes: {
      svg: 'fichier SVG',
      csv: 'fichier CSV',
    },
    fileSizeMb: 'Taille du fichier (MB)',
  },

  linkedRulesTooltip: {
    andMore: 'et plus...',
    linkedRules: {
      widget: '<strong>Widgets</strong> qui utilisent cet élément<br><ul>{rules}</ul>',
      eventfilter: '<strong>Filtres d\'événements</strong>\n<ul>{rules}</ul>',
      linkrule: '<strong>Liens</strong>\n<ul>{rules}</ul>',
      scenario: '<strong>Scénarios</strong>\n<ul>{rules}</ul>',
      declareticketrule: '<strong>Règles de déclaration de tickets</strong>\n<ul>{rules}</ul>',
    },
  },

  massActionsPanel: {
    recordsSelected: '{count} enregistrement sélectionné|{count} enregistrements sélectionnés',
    keepSelectedAfterAction: 'Conserver la sélection après l\'action',
    clearSelection: 'Effacer la sélection',
  },
};
